import { jsx as o } from "react/jsx-runtime";
import { createStyles as i, Box as l } from "@mantine/core";
const m = i((a) => ({
  container: {
    aspectRatio: "1 / 1",
    margin: "0 auto",
    maxWidth: 150,
    marginBottom: a.spacing.xl
  },
  image: {
    display: "block"
  },
  soldOut: {
    opacity: 0.5
  }
})), g = ({ imageAlt: a, imageUrl: s, isSoldOut: e }) => {
  const { classes: t, cx: c } = m();
  return o(l, { className: t.container, children: o("img", { className: c(t.image, { [t.soldOut]: e }), alt: a, src: s, loading: "lazy" }) });
};
export {
  g as Image
};
